import React, { useState } from "react";

export default function WeatherTemp(props) {
  const [unit, setUnit] = useState("celsius");

  function convertToF(event) {
    event.preventDefault();
    setUnit("F");
  }

  function convertToC(event) {
    event.preventDefault();
    setUnit("celsius");
  }

  if (unit === "celsius") {
    return (
      <div className="temp-unit-conversion">
        <span className="temp-value text-left">
          {Math.round(props.celsiusData)}
        </span>
        <span className="unit-symbol"> °C</span> |
        <span className="unit-symbol">
          <a href="/" onClick={convertToF}>
            °F
          </a>
        </span>
      </div>
    );
  } else {
    let F = (props.celsiusData * 9) / 5 + 32;
    return (
      <div className="temp-unit-conversion">
        <span className="temp-value text-left">{Math.round(F)}</span>
        <span className="unit-symbol">
          <a href="/" onClick={convertToC}>
            °C
          </a>
        </span>
        |<span className="unit-symbol">°F</span>
      </div>
    );
  }
}
